import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="landing-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Contact</h3>
            <p>Email: info@casekaizen.com</p>
          </div>
          <div className="footer-section">
            <h3>Navigation</h3>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-of-service">Terms of Service</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 CaseKaizen. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
